<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { reactive, defineEmits, ref } from 'vue';

import validators from '@/utils/validators.ts';
import CardComponent from '@/components/ui/CardComponent.vue';

import type { ValidationRule } from '@/types/utils/validators.type.ts';

const { t } = useI18n();

const emits = defineEmits(['closeModal']);

const props = defineProps<{
  mandateName: string;
}>();

const formValid = ref<boolean>(false);
const reasonRules = ref<ValidationRule[]>([...validators.reasonRules])

const form = reactive({
  reason: null
});
</script>

<template>
  <v-form class="w-100 d-flex align-center">
    <CardComponent with-actions>
      <template #title>
        {{ t('components.refuseMandate.title') }}
      </template>
      <template #item>
        <p class="mb-4">
          {{ t('components.refuseMandate.message', {mandate_name: props.mandateName}) }}
        </p>
        <v-form
          v-model="formValid"
          @submit.prevent="emits('closeModal', form)"
        >
          <v-row class="py-1">
            <v-col cols="12">
              <v-textarea
                v-model="form.reason"
                :label="t('common.inputs.reason.label')"
                :placeholder="t('common.inputs.reason.placeholder')"
                :rules="reasonRules"
                hide-details="auto"
              />
            </v-col>
          </v-row>
        </v-form>
      </template>
      <template #actions>
        <div class="d-flex flex-row justify-space-between ga-4 mt-2">
          <v-btn variant="outlined" @click.prevent="emits('closeModal', false)">
            {{ t('common.buttons.cancel') }}
          </v-btn>
          <v-btn
            :disabled="!formValid"
            type="submit"
            variant="flat"
            color="primary"
            @click="emits('closeModal', form)"
          >
            {{ t('common.buttons.validate') }}
          </v-btn>
        </div>
      </template>
    </CardComponent>
  </v-form>
</template>
